"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ScriberFileType: function() {
        return ScriberFileType;
    },
    uploadFile: function() {
        return uploadFile;
    }
});
var _startFileUpload = require("./startFileUpload");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var ScriberFileType;
(function(ScriberFileType) {
    ScriberFileType["POST_CONTENT"] = "POST_CONTENT";
    ScriberFileType["PROFILE_PICTURE"] = "PROFILE_PICTURE";
    ScriberFileType["PUBLICATION_LOGO"] = "PUBLICATION_LOGO";
    ScriberFileType["CONTACTS"] = "CONTACTS";
    ScriberFileType["IMPORT_CSV"] = "IMPORT_CSV";
    ScriberFileType["EXTERNAL_IMPORT_CONTENT_ZIP"] = "EXTERNAL_IMPORT_CONTENT_ZIP";
    ScriberFileType["EXTERNAL_IMPORT_STRIPE_CSV"] = "EXTERNAL_IMPORT_STRIPE_CSV";
})(ScriberFileType || (ScriberFileType = {}));
var uploadFile = function() {
    var _ref = _asyncToGenerator(function(file, client) {
        var _ref, publicationId, postId, fileType, res, _JSON_parse, fields, url, contentType, formData;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {
                        fileType: ScriberFileType.POST_CONTENT
                    }, publicationId = _ref.publicationId, postId = _ref.postId, fileType = _ref.fileType;
                    return [
                        4,
                        (0, _startFileUpload.startFileUpload)(client, file, {
                            publicationId: publicationId,
                            postId: postId,
                            fileType: fileType
                        })
                    ];
                case 1:
                    res = _state.sent();
                    _JSON_parse = JSON.parse(res.data), fields = _JSON_parse.fields, url = _JSON_parse.url, contentType = _JSON_parse.contentType;
                    formData = new FormData();
                    Object.keys(fields).forEach(function(key) {
                        return formData.append(key, fields[key]);
                    });
                    formData.append("file", file);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            body: formData
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        _objectSpreadProps(_objectSpread({}, res.file), {
                            type: contentType
                        })
                    ];
            }
        });
    });
    return function uploadFile(file, client) {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=index.js.map